import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-audio-overlay',
  templateUrl: './audio-overlay.component.html'
})
export class AudioOverlayComponent implements OnInit {

  @Input()
  visible!: boolean;
  
  @Input()
  audioUrl: string;
    
  @Input()
  showPlayButton!: boolean;

  @Input()
  skipBackState: any;

  @Input()
  skipForwardState: any;

  @Input()
  playPauseButtonState: any;

  @Input()
  audioProgress!: number;

  @Input()
  showAudioProgress!: boolean;

  constructor() {   

    // TODO: setup ngrx effects to listen to paging actions and handle howl
  }

  ngOnInit(): void {

   
  }  
}
